import ScheduleCard from './schedule/Schedule'

export default {
    ScheduleCard
}
